import * as React from 'react';

function Trophy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.11 4.11V3H7.343v1.11H4v1.765c0 1.36.64 3.516 3.797 3.89.719 1.376 2.219 2.579 3.875 2.61h.094c1.671-.031 3.156-1.234 3.875-2.61 3.171-.374 3.812-2.53 3.812-3.89V4.109H16.11zm-2.907 11.828v-2.47s-.844-.405-1.453-.437h-.062c-.61.031-1.454.438-1.454.438v2.469c0 1.656-2.515 1.78-2.515 1.78V19h8v-1.281s-2.516-.125-2.516-1.782zM5.172 6.421V5.203h2.172v2.813c0 .171.015.328.031.5-1.234-.532-2.203-.922-2.203-2.094zm13.094 0c0 1.172-.953 1.562-2.188 2.094.016-.172.031-.329.031-.5V5.203h2.157v1.219z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Trophy;
